/**
 * Returns the part of the props of the MatrixHeader that's relevant to the given component.
 * @param {Object} currentProps - The props of the current component
 * @param {Component} component - The component to get the props for.
 * @returns {Object}
 * @private
 */
export default (currentProps, component) => {
  return Object.keys(component.propTypes).reduce((props, propName) => {
    if (propName in currentProps) {
      props[propName] = currentProps[propName];
    }
    return props;
  }, {});
};
